import { useEffect, useState } from 'react';

// react-router components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// @material-ui core components
import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

//  React components
import MDBox from 'components/MDBox';

//  React example components
import Breadcrumbs from 'examples/Breadcrumbs';

// Custom styles for DashboardNavbar
import { navbar, navbarContainer, navbarRow } from 'examples/Navbars/DashboardNavbar/styles';

//  React context
import { setTransparentNavbar, useMaterialUIController } from 'context';

function DashboardNavbar({ absolute, light, isMini, showRoutsNav, objectName }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { transparentNavbar, fixedNavbar, darkMode } = controller;
  const route = useLocation().pathname.split('/').slice(1);
  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType('sticky');
    } else {
      setNavbarType('static');
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
    */
    // window.addEventListener('scroll', handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    // return () => window.removeEventListener('scroll', handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);
  // const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  // const renderMenu = () => (
  //   <Menu
  //     anchorEl={openMenu}
  //     anchorReference={null}
  //     anchorOrigin={{
  //       vertical: "bottom",
  //       horizontal: "left",
  //     }}
  //     open={Boolean(openMenu)}
  //     onClose={handleCloseMenu}
  //     sx={{ mt: 2 }}
  //   >
  //     <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
  //     <NotificationItem
  //       icon={<Icon>podcasts</Icon>}
  //       title="Manage Podcast sessions"
  //     />
  //     <NotificationItem
  //       icon={<Icon>shopping_cart</Icon>}
  //       title="Payment successfully completed"
  //     />
  //   </Menu>
  // );

  // Styles for the navbar icons
  // const iconsStyle = ({
  //   palette: { dark, white, text },
  //   functions: { rgba },
  // }) => ({
  //   color: () => {
  //     let colorValue = light || darkMode ? white.main : dark.main;
  //
  //     if (transparentNavbar && !light) {
  //       colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
  //     }
  //
  //     return colorValue;
  //   },
  // });
  // console.log('objectName:', objectName);

  return (
    <AppBar
      className="navbar"
      position={absolute ? 'absolute' : navbarType}
      color="inherit"
      sx={theme => navbar(theme, { transparentNavbar, absolute, light, darkMode })}>
      <Toolbar sx={theme => ({ ...navbarContainer(theme) })}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={theme => ({
            ...navbarRow(theme, { isMini }),
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'center', sm: 'center' },
            justifyContent: { xs: 'center', sm: 'flex-start' },
            textAlign: { xs: 'center', sm: 'left' },
          })}
          style={{ width: '100%' }}>
          <Box
            component="img"
            src="/color_logo_black.png"
            alt="Logo"
            sx={{
              position: 'relative',
              height: { xs: 69, md: 46 },
              marginRight: { xs: 0, sm: '15px' },
              marginBottom: { xs: '4px', sm: 0 },
              bottom: { xs: 0, sm: '10px' },
            }}
          />
          <Breadcrumbs
            icon="home"
            showRoutsNav={showRoutsNav}
            // title={`${objectName !== undefined ? objectName : ''} ${route[0] === 'controller' || route[0] === 'data-explorer' ? `(${route[route.length - 1]})` : ``} `}
            // title={`${route[route.length - 1]}`}
            title={`${objectName}`}
            // route={route}
            light={light}
          />
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
